<template>
  <div id="top">
    <div id="logo">
      <img v-show="!$store.state.menu.status" :src="title().src" />

    </div>

    <Icon @click="subMore" :class="{ transform: $store.state.menu.status }" type="md-menu" id="more" />
    <div id="top_center">
      <top-menu></top-menu>
    </div>
    <div id="top_right">
      <msg v-if="false" refs ref="theme"></msg>
      <User ref="user">
        <slot name="user"></slot>
      </User>

      <Icon id="fullScree" @click="screen" :type="$store.state.isFullScreen ? 'md-expand' : 'ios-expand'" />
    </div>
  </div>
</template>
<script>
import User from "./user";
import msg from "./msg.vue";
import topMenu from "./topMenu.vue";
export default {
  components: {
    User,
    msg,
    topMenu,
  },
  data() {
    return {
      childMore: false,
      search: "",
      carNum: 0,
      routeNum: 0,
      //http://localhost:2331/#/xitongkaidan?now=3
      //http://localhost:2331/?t=xhg#/control?now=0
    };
  },

  methods: {
    reachData() {
    },
    subMore: function () {
      this.$store.state.menu.status = !this.$store.state.menu.status;
    },
    //全屏/非全屏切换
    screen() {
      if (this.$store.state.isFullScreen) {
        this.exitScreen();
      } else {
        this.fullScreen();
      }
    },
    //浏览器全屏
    fullScreen() {
      var el = document.documentElement;
      var rfs =
        el.requestFullScreen ||
        el.webkitRequestFullScreen ||
        el.mozRequestFullScreen ||
        el.msRequestFullscreen;
      if (typeof rfs != "undefined" && rfs) {
        rfs.call(el);
      }
      return;
    },
    //退出全屏
    exitScreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
      if (typeof cfs != "undefined" && cfs) {
        cfs.call(el);
      }
    },
    title() {
      var name = this.$store.state.csr.mainTitle;
      var src = this.$store.state.csr.mainLogoPic;
      //mainLogoPic
      return { name, src };
    },
  },

  mounted() { },
};
</script>
<style lang="">
#top {
  height: 50px;
  position: fixed;
  z-index: 10;
  width: 100%;
  left: 0;
  z-index:130;
  background: var(--aidColor);
}
#top #serch_wrap {
  float: left;
  margin-top: 8px;
  margin-left: 20px;
  width: 200px;
}

#top #logo {
  float: left;
  width: 150px;
  min-height: 50px;
  background: #16274f;
}

#top #logo img {
  width: 100%;
  display: block;
}
#top #logo p {
  font-size: 18px;
  margin-top: 10px;
  color: var(--fontColor);
}
#top #more {
  float: left;
  line-height: 50px;
  font-size: 2em;
  width: 2em;
  color: var(--fontColor);
  opacity: 0.5;
  font-weight: lighter;
  transition: transform 0.6s;
}
#top .transform {
  transform: rotate(90deg);
  -ms-transform: rotate(90deg); /* IE 9 */
  -webkit-transform: rotate(90deg); /* Safari and Chrome */
  -o-transform: rotate(90deg); /* Opera */
  -moz-transform: rotate(90deg);
}
#top #more:hover {
  cursor: pointer;
  opacity: 1;
}
#top_center {
  width: calc(100% - 420px);
  height: 50px;
  float: left;
}
#top_right {
  float: right;
  margin-right: 20px;
  width: 170px;
  max-height: 100%;
}
#fullScree {
  font-size: 1.4em;
  float: right;
  line-height: 50px;
  color: var(--fontColor);
  opacity: 0.5;
  margin-left: 20px;
}
#fullScree:hover {
  cursor: pointer;
  opacity: 1;
}

#serch-list,
#no-data {
  background: #fff;
  width: 100%;
  text-align: left;
  padding: 20px 0;
  border: solid 1px #ccc;
  max-height: 400px;
  overflow-y: auto;
}
#serch-list li {
  line-height: 2;
  padding: 0 20px;
  cursor: pointer;
}
#serch-list li:hover {
  background: #e8ebff;
}
#serch-list li a {
  display: block;
}
</style>



// WEBPACK FOOTER //
// ../common/src/components/sys/top.vue